<template>
  <h1 :id="props.id" class="font-display font-bold text-3xl">
    <a v-if="generate" :href="`#${props.id}`" class="no-underline">
      <slot />
    </a>
    <slot v-else />
  </h1>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{ id?: string; style?: HTMLAttributes['style'] }>()

const { headings } = useRuntimeConfig().public.mdc
const generate = computed(
  () =>
    props.id &&
    ((typeof headings?.anchorLinks === 'boolean' &&
      headings?.anchorLinks === true) ||
      (typeof headings?.anchorLinks === 'object' && headings?.anchorLinks?.h1))
)
</script>
